'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.monthBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/monthBefore.js
// module id = 716
// module chunks = 0